import { faker } from '@faker-js/faker'

import { mockLabelCounters } from '~/shared/mocking'

export default function mockEngageChannel({ override = {} } = {}) {
  const channel = {
    id: faker.string.uuid(),
    totalPendingComments: faker.number.int(),
    totalComments: faker.number.int(),
    labelsCount: mockLabelCounters(),
    backfillingComplete: true,
    updatedAt: new Date().toISOString(),
  }

  return {
    ...channel,
    ...override,
  }
}
